export const DEVICE_SINGLE_POLICY = 'deviceSinglePolicy';
export const DEVICE_GET_QUOTES = 'deviceGetQuoteResponse';
export const DEVICE_DIRECT_DEBIT = 'deviceDirectDebit';
export const DEVICE_GET_QUOTE_VALUES = 'deviceGetQuoteValues';
export const DEVICE_ASSUMPTIONS = 'deviceAssumptions';